import { Field } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { DANCE_FLOOR_MAX_FEET } from '@lib/helpers/dance-floor'

/** What DanceFloorFields shows and reports: both numbers as typed. */
interface DanceFloorFieldsProps {
  idPrefix: string
  defaultFeet: string
  incrementFeet: string
  onDefaultFeet: (value: string) => void
  onIncrementFeet: (value: string) => void
  /** Set when both numbers are filled in and they are not a size a plan can offer. */
  error: string | null
}

/**
 * The two numbers a dance floor is: the size it starts at, and the step a
 * placed one may grow by. There is no drawing. Both forms that can create a
 * piece use this, so a venue, a vendor, and a client bringing their own all
 * ask the question the same way.
 */
export function DanceFloorFields({
  idPrefix,
  defaultFeet,
  incrementFeet,
  onDefaultFeet,
  onIncrementFeet,
  error,
}: DanceFloorFieldsProps) {
  return (
    <>
      <Field
        label="Default size (ft)"
        htmlFor={`${idPrefix}-dance-default`}
        hint="How big a new dance floor is. It is always square."
      >
        <Input
          id={`${idPrefix}-dance-default`}
          type="number"
          min={0.01}
          max={DANCE_FLOOR_MAX_FEET}
          step="0.01"
          value={defaultFeet}
          onChange={(e) => onDefaultFeet(e.target.value)}
          placeholder="e.g. 10"
        />
      </Field>
      <Field
        label="Size increment (ft)"
        htmlFor={`${idPrefix}-dance-increment`}
        hint="How much a placed dance floor can grow. 10 ft with a 1 ft increment can be 11×11 or 12×12, never 10×11."
        {...(error !== null ? { error } : {})}
      >
        <Input
          id={`${idPrefix}-dance-increment`}
          type="number"
          min={0.01}
          max={DANCE_FLOOR_MAX_FEET}
          step="0.01"
          value={incrementFeet}
          onChange={(e) => onIncrementFeet(e.target.value)}
          placeholder="e.g. 1"
        />
      </Field>
    </>
  )
}
